import styled, { css } from 'styled-components';
import { HeadingProps } from '.';

export const Container = styled.div<HeadingProps>`
  ${({ theme, $size, $weight, $align, $highContrast }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight[$weight]};
      line-height: ${theme.typography.font.line_height[$size]}px;
      text-align: ${$align};
      color: ${$highContrast
        ? theme.tokens.colors.text
        : theme.colors.neutral.neutral_alpha[11]};
    `;
  }};

  ${({ $quebraTexto }) => {
    if (!$quebraTexto)
      return css`
        white-space: nowrap;
        overflow: hidden;
      `;

    return css`
      word-break: break-word;
    `;
  }}
`;
